import React, { useState, useEffect } from 'react'
import Sidebar from '../include/Sidebar'
import Header from '../include/Header'
import { Link } from 'react-router-dom'
import { MultiSelect } from "react-multi-select-component";
import axios from 'axios';
import { PAY_URL } from '../../../BaseURL';

const ManageEmployee = () => {
    const [projectsList, setProjectsList] = useState([]);
    const [selectedProjects, setSelectedProjects] = useState([]);

    useEffect(() => {
        getProjectList();
    }, []);

    const getProjectList = () => {
        axios.get(`${PAY_URL}/user/get-project`, {
            headers: { Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN') }
        }).then((response) => {
            if (response.data.success) {
                const formatted = response.data.data.map((p) => ({ label: p.name, value: p._id }));
                setProjectsList(formatted);
            }
        }).catch((err) => console.log(err));
    };
    return (
        <div className="main-wrapper">
            <Header />
            <Sidebar />

            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col">
                                <h3 className="page-title">Add Employee</h3>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to='/admin/dashboard'>Dashboard</Link></li>
                                    <li className="breadcrumb-item"><Link to='/admin/employee-management'>Employee Management</Link></li>
                                    <li className="breadcrumb-item active">Add Employee</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="card p-3 basicform">
                        <div className=" mb-3 titleForm border-bottom">
                            <h4 className="">Basic Information</h4>
                        </div>

                        <div className="row card_id">
                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">

                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label for="cardNum" className="form-label">Card Number</label>
                                        <input type="text" className="form-control" id="cardNum" />
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">

                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label for="email" className="form-label">Email Id </label>
                                        <input type="text" className="form-control" id="email" />
                                    </div>
                                </div>

                            </div>

                            <div className="col-md-12 col-lg-12 col-xxl-12 col-sm-12">
                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label className="form-label">Projects (Multiple)</label>
                                        <MultiSelect
                                            options={projectsList}
                                            value={selectedProjects}
                                            onChange={setSelectedProjects}
                                            labelledBy="Select Projects"
                                            hasSelectAll={false}
                                            className="form-control p-0"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="row card_id">
                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">

                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label for="firstName" className="form-label">First Name</label>
                                        <input type="text" className="form-control" id="firstName" />
                                    </div>
                                </div>

                            </div>
                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">

                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label for="middleName" className="form-label">Middle Name</label>
                                        <input type="text" className="form-control" id="middleName" />
                                    </div>
                                </div>

                            </div>
                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">

                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label for="lastName" className="form-label">Last Name</label>
                                        <input type="text" className="form-control" id="lastName" />
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="row card_id">
                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">

                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label for="gender" className="form-label">Gender</label>
                                        <select className="form-select form-control" aria-label="Default select example">
                                            <option selected>Select Gender</option>
                                            <option value="1">Male</option>
                                            <option value="2">Female</option>
                                        </select>
                                    </div>
                                </div>

                            </div>
                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">

                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label for="selectDate" className="form-label">DOB</label>
                                        <input type="date" className="form-control" id="selectDate" />
                                    </div>
                                </div>

                            </div>
                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">

                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label for="phoneNumber" className="form-label">Phone Number</label>
                                        <input type="number" className="form-control" id="phoneNumber" />
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="row card_id">
                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">

                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label for="fileUpload" className="form-label">Images</label>
                                        <input type="file" className="form-control" id="fileUpload" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">

                                <div className="cardNum">
                                    <div className="mb-3">
                                        <div className="cardNum">
                                            <div className="mb-3">
                                                <label for="adharNumber" className="form-label">Adhar Number </label>
                                                <input type="number" className="form-control" id="adharNumber" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">

                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label for="panCard" className="form-label">Pan Card Number</label>
                                        <input type="text" className="form-control" id="panCard" />
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>


                    <div className="card p-3 personalform ">
                        <div className=" mb-3 titleForm border-bottom">
                            <h4 className="">Personal Information</h4>
                        </div>

                        <div className="row card_id">
                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">

                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label for="designation" className="form-label">Designation</label>
                                        <select className="form-select form-control" aria-label="Default select example">
                                            <option selected>Select your Designation</option>
                                            <option value="1">Designation 1</option>
                                            <option value="2">Designation 2</option>
                                            <option value="2">Designation 3</option>
                                            <option value="2">Designation 4</option>
                                        </select>
                                    </div>
                                </div>


                            </div>

                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">

                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label for="shift" className="form-label">Shift</label>
                                        <select className="form-select form-control" aria-label="Default select example">
                                            <option selected>Select your Shift</option>
                                            <option value="1">shift 1</option>
                                            <option value="2">shift 1</option>
                                            <option value="3">shift 3</option>
                                            <option value="4">shift 4</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">

                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label for="uanno" className="form-label">Uan No</label>
                                        <input type="text" className="form-control" id="uanno" />
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="row card_id">
                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">

                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label for="intime" className="form-label">In Time </label>
                                        <input type="number" className="form-control" id="intime" />
                                    </div>
                                </div>

                            </div>
                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">

                                <div className="cardNum">
                                    <div className="mb-3">
                                        <div className="cardNum">
                                            <div className="mb-3">
                                                <label for="outTime" className="form-label">Out Time </label>
                                                <input type="number" className="form-control" id="outTime" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">

                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label for="holiday" className="form-label">Holiday</label>
                                        <input type="number" className="form-control" id="holiday" />
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div className="row card_id">
                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">

                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label for="joiningDate" className="form-label">Joining Date</label>
                                        <input type="number" className="form-control" id="joiningDate" />
                                    </div>
                                </div>

                            </div>
                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">

                                <div className="cardNum">
                                    <div className="mb-3">
                                        <div className="cardNum">
                                            <div className="mb-3">
                                                <label for="leavingDate" className="form-label">Leaving Date</label>
                                                <input type="number" className="form-control" id="leavingDate" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">


                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label for="salaryadd" className="form-label">Salary</label>
                                        <input type="text" className="form-control" id="salaryadd" />
                                    </div>
                                </div>


                            </div>

                            <div className="row card_id">
                                <div className="col-md-12 col-lg-12 col-xxl-12 col-sm-12">

                                    <div className="cardNum">
                                        <div className="mb-3">
                                            <label for="leavingReason" className="form-label">Leaving Reason</label>
                                            <textarea className="form-control" placeholder="Leave a comment here"
                                                id="leavingReason"></textarea>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>


                    </div>

                    <div className="card p-3 ">
                        <div className=" mb-3 titleForm border-bottom">
                            <h4 className="">Permanent & Present Address</h4>
                        </div>
                        <div className="p-2 card  Addressform">
                            <div className="row card_id">
                                <h4 className="bg-body-secondary p-2" style={{ borderRadius: "3px" }}>Permanent Address</h4>

                                <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                    <div className="cardNum">
                                        <div className="mb-3">
                                            <label for="address1" className="form-label">Address</label>
                                            <input className="form-control" id="address1" rows="3" />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                    <div className="cardNum">
                                        <div className="mb-3">
                                            <label for="address2" className="form-label">Address 2</label>
                                            <input className="form-control" id="address2" rows="3" />
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                    <div className="cardNum">
                                        <div className="mb-3">
                                            <label for="address3" className="form-label">Address 3</label>
                                            <input className="form-control" id="address3" rows="3" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row card_id">
                                <div className="col-md-4 col-lg-4 col-xxl-4">
                                    <div className="cardNum">
                                        <div className="mb-3">
                                            <label for="State" className="form-label">State</label>
                                            <select className="form-select form-control"
                                                aria-label="Default select example">
                                                <option selected>Select your State</option>
                                                <option value="1">Gujarat</option>
                                                <option value="2">Goa </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4 col-lg-4 col-xxl-4">
                                    <div className="cardNum">
                                        <div className="mb-3">
                                            <label for="city" className="form-label">City</label>
                                            <select className="form-select form-control"
                                                aria-label="Default select example">
                                                <option selected>Select your city</option>
                                                <option value="1">Surat </option>
                                                <option value="2">Panaji</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4 col-lg-4 col-xxl-4">
                                    <div className="cardNum">
                                        <div className="mb-3">
                                            <label for="pinCode" className="form-label">Pincode</label>
                                            <input type="number" className="form-control" id="pinCode" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className=" card m-0 checkCard">
                            <div className="card_id ">
                                <div className="d-flex align-items-center gap-2 bg-body-secondary ">
                                    <h4 className="p-2 m-0" style={{ borderRadius: "3px" }}>Present Address</h4>
                                    <div className="d-flex gap-2 align-center">
                                        <input type="checkbox" className="d-flex form-check-input m-0" data-bs-toggle="collapse"
                                            href="#collapseExample" role="button" aria-expanded="false"
                                            aria-controls="collapseExample" placeholder="" />
                                        <label for=""> Present Address Same As Permanent Address</label>
                                    </div>
                                </div>
                                <div className="collapse mt-3" id="collapseExample">
                                    <div className=" card-body">
                                        <div className="row">
                                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                                <div className="cardNum">
                                                    <div className="mb-3">
                                                        <label for="address1" className="form-label">Address</label>
                                                        <input className="form-control" id="address1" rows="3" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                                <div className="cardNum">
                                                    <div className="mb-3">
                                                        <label for="address2" className="form-label">Address 2</label>
                                                        <input className="form-control" id="address2" rows="3" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">

                                                <div className="cardNum">
                                                    <div className="mb-3">
                                                        <label for="address3" className="form-label">Address 3</label>
                                                        <input className="form-control" id="address3" rows="3" />
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div className="row card_id">
                                            <div className="col-md-4 col-lg-4 col-xxl-4">

                                                <div className="cardNum">
                                                    <div className="mb-3">
                                                        <label for="State" className="form-label">State</label>
                                                        <select className="form-select form-control"
                                                            aria-label="Default select example">
                                                            <option selected>Select your State</option>
                                                            <option value="1">Gujarat</option>
                                                            <option value="2">Goa </option>
                                                        </select>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="col-md-4 col-lg-4 col-xxl-4">

                                                <div className="cardNum">
                                                    <div className="mb-3">
                                                        <label for="city" className="form-label">City</label>
                                                        <select className="form-select form-control"
                                                            aria-label="Default select example">
                                                            <option selected>Select your city</option>
                                                            <option value="1">Surat </option>
                                                            <option value="2">Panaji</option>
                                                        </select>
                                                    </div>
                                                </div>

                                            </div>

                                            <div className="col-md-4 col-lg-4 col-xxl-4">

                                                <div className="cardNum">
                                                    <div className="mb-3">
                                                        <label for="pinCode" className="form-label">Pincode</label>
                                                        <input type="number" className="form-control" id="pinCode" />
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card p-3 Blacklistform ">
                        <div className=" mb-3 titleForm border-bottom">
                            <h4 className="">Black List Information</h4>
                        </div>
                        <div className="row card_id">
                            <div className="col-md-6 col-lg-6 col-xxl-6 col-sm-12">

                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label for="blackList" className="form-label">Black List</label>
                                        <input type="text" className="form-control" id="blackList" />
                                    </div>
                                </div>

                            </div>
                            <div className="col-md-6 col-lg-6 col-xxl-6 col-sm-12">

                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label for="blackreason" className="form-label">Black List Reason</label>
                                        <input type="text" className="form-control" id="blackreason" />
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>

                    <div className="card p-3 Blacklistform ">
                        <div className=" mb-3 titleForm border-bottom">
                            <h4 className="">Emergency Contact</h4>
                        </div>

                        <div className="row card_id">
                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">

                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label for="Emname" className="form-label">Name</label>
                                        <input type="text" className="form-control" id="Emname" />
                                    </div>
                                </div>

                            </div>

                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">

                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label for="relationship" className="form-label">Relationship</label>
                                        <input type="text" className="form-control" id="relationship" />
                                    </div>
                                </div>

                            </div>
                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">

                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label for="emPhone" className="form-label">Phone Number</label>
                                        <input type="text" className="form-control" id="emPhone" />
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="row card_id mt-4 sm-mt-3">
                            <div className=" col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                <div className="cardNum">
                                    <div className="mb-3 d-flex gap-2">
                                        <button className="btn btn-primary w-50">Submit</button>
                                        <button className="btn btn-outline-secondary w-50">Reset</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ManageEmployee